import { render, staticRenderFns } from "./ActiveSubstancesTable.vue?vue&type=template&id=40651b16&"
import script from "./ActiveSubstancesTable.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstancesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports